export type NavigationItem = {
    label: string;
    to: string;
};

export const mainNavigation: NavigationItem[] = [
    { label: "ACCUEIL", to: "/" },
    { label: "ACTUALITÉS", to: "/actualites" },
    { label: "ÉVÉNEMENTS", to: "/evenements" },
    { label: "CALENDRIER", to: "/calendrier" },
    { label: "CLASSEMENT", to: "/classement" },
    { label: "ÉQUIPES", to: "/equipes" },
];